/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `variant_0_percent` - 0 EUR
 * * `variant_1_percent` - Var.1 = 1%
 * * `variant_10_percent` - Var.2 = 10%
 */
export enum PartialFranchiseEnum {
  VARIANT_0_PERCENT = 'variant_0_percent',
  VARIANT_1_PERCENT = 'variant_1_percent',
  VARIANT_10_PERCENT = 'variant_10_percent',
}
